module.exports = __webpack_public_path__ + "img/userlogs.daeea9dd.svg";